import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import AppVideoHero from './components/AppVideoHero';
import Hotels from './components/Hotels';
import Activities from './components/Activities';
import SearchPage from './components/SearchPage';
import HotelSearchPage from './components/HotelSearchPage';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import HotelDetail from './components/HotelDetail';
import PackageDetail from './components/PackageDetail';
import HomeStay from './components/HomeStay';
import Villa from './components/Villa';
import Flights from './components/Flights';
import Taxi from './components/Taxi';
import Tours from './components/Tours';
import Yatch from './components/Yatch';
import ListProperty from './components/ListProperty';
import MyTrip from './components/MyTrip';
import PackagesPage from './components/PackagesPage';
import Home from './components/Home';
import { SelectedActivitiesProvider } from './components/SelectedActivitiesContext';
import { DateProvider } from './components/DateContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <DateProvider>
        <SelectedActivitiesProvider>
          <Helmet>
            <title>GoaDeals | Goa Tour Packages, Hotels, Sightseeing &amp; Activities</title>
            <meta name="description" content="Book customised Goa holiday packages, hotels in Calangute, private transfers, North and South Goa tours, dinner cruises, and activities with local Goa support." />
            <link rel="canonical" href="https://goadeals.in/" />
          </Helmet>
          <div className="App">
            <Header />
            <AppVideoHero />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/hotels" element={<ProtectedRoute><HotelSearchPage /></ProtectedRoute>} />
              <Route path="/hotels-old" element={<ProtectedRoute><Hotels /></ProtectedRoute>} />
              <Route path="/hotels-list" element={<ProtectedRoute><Hotels initialCategory="all" hideCategoryFilters={false} /></ProtectedRoute>} />
              <Route path="/activities" element={<ProtectedRoute><Activities /></ProtectedRoute>} />
              <Route path="/hotel/:id" element={<ProtectedRoute><HotelDetail /></ProtectedRoute>} />
              <Route path="/package/:id" element={<ProtectedRoute><PackageDetail /></ProtectedRoute>} />
              <Route path="/packages" element={<ProtectedRoute><PackagesPage /></ProtectedRoute>} />
              <Route path="/homestay" element={<ProtectedRoute><HomeStay /></ProtectedRoute>} />
              <Route path="/villa" element={<ProtectedRoute><Villa /></ProtectedRoute>} />
              <Route path="/flights" element={<ProtectedRoute><Flights /></ProtectedRoute>} />
              <Route path="/taxi" element={<ProtectedRoute><Taxi /></ProtectedRoute>} />
              <Route path="/tours" element={<ProtectedRoute><Tours /></ProtectedRoute>} />
              <Route path="/yatch" element={<ProtectedRoute><Yatch /></ProtectedRoute>} />
              <Route path="/list-property" element={<ListProperty />} />
              <Route path="/my-trip" element={<ProtectedRoute><MyTrip /></ProtectedRoute>} />
            </Routes>
            <Footer />
            <WhatsAppButton />
          </div>
        </SelectedActivitiesProvider>
      </DateProvider>
    </Router>
  );
}

export default App;
